module.exports = "/img/_/_/_/assets/images/creeper/book/common//5.jpg?8056c42f42f179be149ca75c2933b455";